import React from 'react';
import UnitItemListActions, { Actions } from './UnitItemListActions';
import UnitItemListActionsService from '../../../services/UnitItemListActionsService';
import UnitItemListService from '../../../services/UnitItemListService';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Roles } from '../../../../../core/util';

const UnitItemListActionsContainer = (props) => (
  <UnitItemListActions
    submitting={UnitItemListActionsService.submit.fetching}
    onAction={UnitItemListActionsService.handleAction.bind(null, props.course.id, props.module.id, props.unit.id)}
    actions={
      UnitItemListActionsService.enableShift
        ? [Actions.CANCEL, ...(UnitItemListService.selectedRows.length ? [Actions.SHIFT] : [Actions.SHIFT_DISABLED])]
        : [
            Actions.IMAGE_PROMPT,
            Actions.IMAGE,
            Actions.AUDIO,
            Actions.BACK,
            Actions.ITEM_SHIFT,
            ...([Roles.ADMIN, Roles.SUPPORT].includes(localStorage.role) || props.unit.createdBy === localStorage.id
              ? [Actions.ADD_NEW_ITEM]
              : []),
          ]
    }
  />
);

UnitItemListActionsContainer.propTypes = {
  course: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  module: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  unit: PropTypes.shape({
    id: PropTypes.string.isRequired,
    createdBy: PropTypes.string.isRequired,
  }).isRequired,
};

export default observer(UnitItemListActionsContainer);
